const state = {
  paramsClient: {
    client: '',
    code: '',
    show_generic_display: '0',
    show_video_intro: '0',
    display_default_urls: {
      facebook: '',
      twitter: '',
      video: '',
      youtube: '',
      linkedin: '',
      image_url: '',
      url_media: '',
    },
    display_default_blocks: [
      {
        name: 'Areas',
        blocks: ['column1', 'column2', 'column3', 'column3-7'],
      },
      {
        name: 'Text',
        blocks: ['text', 'custom-title', 'custom-sharing', 'link', 'link-block', 'quote'],
      },
    ],
    display_devices: [
      {
        name: 'landscape',
        className: 'icon-landscape',
        x: '70',
        y: '39.375',
        height: '39.375vw',
        width: '70vw',
        widthMedia: '',
      },
      {
        name: 'portrait',
        className: 'icon-portrait',
        x: '30',
        y: '40',
        height: '40vw',
        width: '30vw',
        widthMedia: '',
      },
    ],
    display_fonts: [
      {
        value: 'Corporate A BQ',
        name: 'Corporate A BQ',
      },
    ],
    display_custom_style_manager: [
      {
        name: 'Disposition',
        buildProps: [
          'float',
          'params-disposition',
          'display',
          'position',
          'top',
          'right',
          'left',
          'bottom',
        ],
        properties: [
          {
            name: 'Alignment',
            property: 'float',
            type: 'radio',
            defaults: 'none',
            list: [
              {
                value: 'none',
                className: 'fa fa-times',
              },
              {
                value: 'left',
                className: 'fa fa-align-left',
              },
              {
                value: 'right',
                className: 'fa fa-align-right',
              },
            ],
          },
          {
            property: 'position',
            type: 'select',
            defaults: 'relative',
          },
          {
            property: 'params-disposition',
            icon: '',
          },
        ],
      },
      {
        name: 'Dimension',
        open: false,
        buildProps: [
          'width',
          'flex-width',
          'height',
          'params-dimension',
          'max-width',
          'min-height',
        ],
        properties: [
          {
            property: 'params-dimension',
            icon: '',
          },
          {
            name: 'Width',
            property: 'width',
            unit: '%',
            units: ['%'],
          },
          {
            name: 'Height',
            property: 'height',
            unit: '%',
            units: ['%'],
          },
          {
            name: 'Max width',
            property: 'max-width',
            unit: '%',
            units: ['%'],
          },
          {
            name: 'Min height',
            property: 'min-height',
            unit: '%',
            units: ['%'],
          },
          {
            id: 'flex-width',
            type: 'integer',
            name: 'Width',
            units: ['px', '%'],
            property: 'flex-basis',
            defaults: '50',
            toRequire: 1,
          },
        ],
      },
      {
        name: 'Spacing',
        open: false,
        buildProps: ['margin', 'padding'],
        properties: [
          {
            property: 'margin',
            properties: [
              {
                name: 'Top',
                property: 'margin-top',
              },
              {
                name: 'Right',
                property: 'margin-right',
              },
              {
                name: 'Bottom',
                property: 'margin-bottom',
              },
              {
                name: 'Left',
                property: 'margin-left',
              },
            ],
          },
          {
            property: 'padding',
            properties: [
              {
                name: 'Top',
                property: 'padding-top',
              },
              {
                name: 'Right',
                property: 'padding-right',
              },
              {
                name: 'Bottom',
                property: 'padding-bottom',
              },
              {
                name: 'Left',
                property: 'padding-left',
              },
            ],
          },
        ],
      },
      {
        name: 'Text',
        open: false,
        buildProps: [
          'font-family',
          'font-size',
          'font-weight',
          'letter-spacing',
          'color',
          'line-height',
          'text-align',
          'text-decoration',
          'text-shadow',
        ],
        properties: [
          {
            name: 'Font size',
            property: 'font-size',
            unit: 'vw',
            units: ['vw', 'vh'],
            defaults: '1',
          },
          {
            name: 'Font',
            property: 'font-family',
          },
          {
            name: 'Weight',
            property: 'font-weight',
          },
          {
            name: 'Font color',
            property: 'color',
          },
          {
            name: 'Letter spacing',
            property: 'letter-spacing',
          },
          {
            property: 'text-align',
            type: 'radio',
            defaults: 'left',
            list: [
              {
                value: 'left',
                name: 'Left',
                className: 'fa fa-align-left',
              },
              {
                value: 'center',
                name: 'Center',
                className: 'fa fa-align-center',
              },
              {
                value: 'right',
                name: 'Right',
                className: 'fa fa-align-right',
              },
              {
                value: 'justify',
                name: 'Justify',
                className: 'fa fa-align-justify',
              },
            ],
          },
          {
            property: 'text-decoration',
            type: 'radio',
            defaults: 'none',
            list: [
              {
                value: 'none',
                name: 'None',
                className: 'fa fa-times',
              },
              {
                value: 'underline',
                name: 'underline',
                className: 'fa fa-underline',
              },
              {
                value: 'line-through',
                name: 'Line-through',
                className: 'fa fa-strikethrough',
              },
            ],
          },
          {
            property: 'text-shadow',
            properties: [
              {
                name: 'X position',
                property: 'text-shadow-h',
              },
              {
                name: 'Y position',
                property: 'text-shadow-v',
              },
              {
                name: 'Blur',
                property: 'text-shadow-blur',
              },
              {
                name: 'Color',
                property: 'text-shadow-color',
              },
            ],
          },
        ],
      },
      {
        name: 'Background',
        open: false,
        buildProps: ['background-color', 'background'],
        properties: [
          {
            property: 'background',
            properties: [
              {
                name: 'Image',
                property: 'background-image',
                className: 'background-image-upload',
              },
              {
                name: 'Repeat',
                property: 'background-repeat',
                type: 'radio',
                defaults: 'row',
                list: [
                  {
                    value: 'repeat',
                    name: 'Repeat',
                    className: 'icons-layers-background icon-repeat',
                    title: 'Repeat',
                  },
                  {
                    value: 'repeat-x',
                    name: 'Repeat-x',
                    className: 'icons-layers-background icon-repeat-x',
                    title: 'Repeat-x',
                  },
                  {
                    value: 'repeat-y',
                    name: 'Repeat-y',
                    title: 'Repeat-y',
                    className: 'icons-layers-background icon-repeat-y',
                  },
                  {
                    value: 'no-repeat',
                    name: 'no-repeat',
                    title: 'no-repeat',
                    className: 'icons-layers-background icon-no-repeat',
                  },
                ],
              },
              {
                name: 'Size',
                property: 'background-size',
                type: 'radio',
                defaults: 'row',
                list: [
                  {
                    value: 'auto',
                    name: 'Auto',
                    className: 'icons-layers-size icon-auto',
                    title: 'Auto',
                  },
                  {
                    value: 'cover',
                    name: 'Cover',
                    className: 'icons-layers-size icon-cover',
                    title: 'Cover',
                  },
                  {
                    value: 'contain',
                    name: 'Contain',
                    title: 'Contain',
                    className: 'icons-layers-size icon-contain',
                  },
                ],
              },
              {
                name: 'Position',
                property: 'background-position',
                type: 'radio',
                defaults: 'row',
                list: [
                  {
                    value: '0% 0%',
                    name: 'left top',
                    className: 'icon-background-position icon-left-top',
                    title: 'En haut à gauche',
                  },
                  {
                    value: '50% 0%',
                    name: 'center top',
                    className: 'icon-background-position icon-center-top',
                    title: 'En haut au centre',
                  },
                  {
                    value: '100% 0%',
                    name: 'right top',
                    className: 'icon-background-position icon-right-top',
                    title: 'En haut à droite',
                  },
                  {
                    value: '0% 50%',
                    name: 'left center',
                    className: 'icon-background-position icon-left-center',
                    title: 'Au centre à gauche',
                  },
                  {
                    value: '50% 50%',
                    name: 'center center',
                    className: 'icon-background-position icon-center-center',
                    title: 'Au centre au centre',
                  },
                  {
                    value: '100% 50%',
                    name: 'right center',
                    className: 'icon-background-position icon-right-center',
                    title: 'Au centre à droite',
                  },
                  {
                    value: '0% 100%',
                    name: 'left bottom',
                    className: 'icon-background-position icon-left-bottom',
                    title: 'En bas à gauche',
                  },
                  {
                    value: '50% 100%',
                    name: 'center bottom',
                    className: 'icon-background-position icon-center-bottom',
                    title: 'En bas au centre',
                  },
                  {
                    value: '100% 100%',
                    name: 'right bottom',
                    className: 'icon-background-position icon-right-bottom',
                    title: 'En bas à droite',
                  },
                ],
              },
              {
                name: 'Attachment',
                property: 'background-attachment',
              },
            ],
          },
        ],
      },
      {
        name: 'Border',
        open: false,
        buildProps: [],
      },
      {
        name: 'Decoration',
        open: false,
        buildProps: [
          'opacity',
          'box-shadow',
          'params-decoration',
          'transition',
          'perspective',
          'transform',
        ],
        properties: [
          {
            property: 'params-decoration',
            icon: '',
          },
          {
            type: 'slider',
            property: 'opacity',
            defaults: 1,
            step: 0.01,
            max: 1,
            min: 0,
          },
          {
            property: 'box-shadow',
            properties: [
              {
                name: 'X position',
                property: 'box-shadow-h',
              },
              {
                name: 'Y position',
                property: 'box-shadow-v',
              },
              {
                name: 'Blur',
                property: 'box-shadow-blur',
              },
              {
                name: 'Spread',
                property: 'box-shadow-spread',
              },
              {
                name: 'Color',
                property: 'box-shadow-color',
              },
              {
                name: 'Shadow type',
                property: 'box-shadow-type',
              },
            ],
          },
          {
            property: 'transition',
            properties: [
              {
                name: 'Property',
                property: 'transition-property',
              },
              {
                name: 'Duration',
                property: 'transition-duration',
              },
              {
                name: 'Easing',
                property: 'transition-timing-function',
              },
            ],
          },
          {
            property: 'transform',
            properties: [
              {
                name: 'Rotate X',
                property: 'transform-rotate-x',
              },
              {
                name: 'Rotate Y',
                property: 'transform-rotate-y',
              },
              {
                name: 'Rotate Z',
                property: 'transform-rotate-z',
              },
              {
                name: 'Scale X',
                property: 'transform-scale-x',
              },
              {
                name: 'Scale Y',
                property: 'transform-scale-y',
              },
              {
                name: 'Scale Z',
                property: 'transform-scale-z',
              },
            ],
          },
        ],
      },
      {
        name: 'Responsive',
        open: false,
        properties: [
          {
            name: 'Flex Container',
            property: 'display',
            type: 'select',
            defaults: 'block',
            list: [
              {
                value: 'block',
                name: 'Disable',
              },
              {
                value: 'flex',
                name: 'Enable',
              },
            ],
          },
          {
            name: 'Flex Parent',
            property: 'label-parent-flex',
            type: 'integer',
          },
          {
            name: 'Direction',
            property: 'flex-direction',
            type: 'radio',
            defaults: 'row',
            list: [
              {
                value: 'row',
                name: 'Row',
                className: 'icons-flex icon-dir-row',
                title: 'Row',
              },
              {
                value: 'row-reverse',
                name: 'Row reverse',
                className: 'icons-flex icon-dir-row-rev',
                title: 'Row reverse',
              },
              {
                value: 'column',
                name: 'Column',
                title: 'Column',
                className: 'icons-flex icon-dir-col',
              },
              {
                value: 'column-reverse',
                name: 'Column reverse',
                title: 'Column reverse',
                className: 'icons-flex icon-dir-col-rev',
              },
            ],
          },
          {
            name: 'Justify',
            property: 'justify-content',
            type: 'radio',
            defaults: 'flex-start',
            list: [
              {
                value: 'flex-start',
                className: 'icons-flex icon-just-start',
                title: 'Start',
              },
              {
                value: 'flex-end',
                title: 'End',
                className: 'icons-flex icon-just-end',
              },
              {
                value: 'space-between',
                title: 'Space between',
                className: 'icons-flex icon-just-sp-bet',
              },
              {
                value: 'space-around',
                title: 'Space around',
                className: 'icons-flex icon-just-sp-ar',
              },
              {
                value: 'center',
                title: 'Center',
                className: 'icons-flex icon-just-sp-cent',
              },
            ],
          },
          {
            name: 'Align',
            property: 'align-items',
            type: 'radio',
            defaults: 'center',
            list: [
              {
                value: 'flex-start',
                title: 'Start',
                className: 'icons-flex icon-al-start',
              },
              {
                value: 'flex-end',
                title: 'End',
                className: 'icons-flex icon-al-end',
              },
              {
                value: 'stretch',
                title: 'Stretch',
                className: 'icons-flex icon-al-str',
              },
              {
                value: 'center',
                title: 'Center',
                className: 'icons-flex icon-al-center',
              },
            ],
          },
          {
            name: 'Flex Children',
            property: 'label-parent-flex',
            type: 'integer',
          },
          {
            name: 'Order',
            property: 'order',
            type: 'integer',
            defaults: 0,
            min: 0,
          },
          {
            name: 'Flex',
            property: 'flex',
            type: 'composite',
            properties: [
              {
                name: 'Grow',
                property: 'flex-grow',
                type: 'integer',
                defaults: 0,
                min: 0,
              },
              {
                name: 'Shrink',
                property: 'flex-shrink',
                type: 'integer',
                defaults: 0,
                min: 0,
              },
              {
                name: 'Basis',
                property: 'flex-basis',
                type: 'integer',
                units: ['px', '%', ''],
                unit: '',
                defaults: 'auto',
              },
            ],
          },
          {
            name: 'Align',
            property: 'align-self',
            type: 'radio',
            defaults: 'auto',
            list: [
              {
                value: 'auto',
                name: 'Auto',
              },
              {
                value: 'flex-start',
                title: 'Start',
                className: 'icons-flex icon-al-start-flex',
              },
              {
                value: 'flex-end',
                title: 'End',
                className: 'icons-flex icon-al-end-flex',
              },
              {
                value: 'stretch',
                title: 'Stretch',
                className: 'icons-flex icon-al-str-flex',
              },
              {
                value: 'center',
                title: 'Center',
                className: 'icons-flex icon-al-center-flex',
              },
            ],
          },
        ],
      },
    ],
  },
  permissions: [],
};
// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  pushParamsClient(state, Params) {
    state.paramsClient = Params;
  },
  setPermissions(state, modules) {
    state.permissions = modules;
  },
  setUrlMedia(state, urlMedia) {
    state.paramsClient.display_default_urls.url_media = urlMedia;
  },
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
  pushParamsClient: ({ state, commit }, Params) => commit('pushParamsClient', Params),
  setPermissions: ({ state, commit }, modules) => commit('setPermissions', modules),
  setUrlMedia: ({ state, commit }, urlMedia) => commit('setUrlMedia', urlMedia),
};

// getters are functions
const getters = {
  /**
   * Get
   */
  getParamsClients: state => state.paramsClient,
  hasPermission: state => permissions => permissions.split(',').some(v => state.permissions[v]),
  getPermissions: state => state.permissions,
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/paramsClient-data.js